"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isActualSearchTimestamp = exports.handleEmptyQueryParams = exports.getRestSecondsBySearchTime = exports.getInitialDatesForQuery = exports.getGroupQueryParamByHotelsCount = exports.getErrorsByQuery = exports.generateNextAvailableSearchTime = void 0;
var _moment = _interopRequireDefault(require("moment"));
var R = _interopRequireWildcard(require("ramda"));
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var THROTTLE_SECONDS = 5;
var generateNextAvailableSearchTime = exports.generateNextAvailableSearchTime = function generateNextAvailableSearchTime() {
  return Number((0, _moment.default)().add(THROTTLE_SECONDS, 'seconds').format('X'));
};
var getRestSecondsBySearchTime = exports.getRestSecondsBySearchTime = function getRestSecondsBySearchTime(nextSearchTimestamp) {
  return (0, _moment.default)(nextSearchTimestamp, 'X').diff((0, _moment.default)(), 'seconds');
};
var isActualSearchTimestamp = exports.isActualSearchTimestamp = function isActualSearchTimestamp(nextSearchTimestamp) {
  return (0, _moment.default)().diff((0, _moment.default)(nextSearchTimestamp, 'X'), 'seconds') < 0;
};
var getErrorsByQuery = exports.getErrorsByQuery = function getErrorsByQuery(query) {
  return R.call(R.pipe(R.toPairs, R.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      paramName = _ref2[0],
      paramValue = _ref2[1];
    return {
      paramName: paramName,
      paramValue: paramValue
    };
  }), R.map(R.cond([[function (_ref3) {
    var paramName = _ref3.paramName;
    return paramName === _fn.QUERY_PARAMS.DATES;
  }, function (_ref4) {
    var _ref4$paramValue = _ref4.paramValue,
      from = _ref4$paramValue.from,
      to = _ref4$paramValue.to;
    return R.and(from.diff((0, _moment.default)(), 'days') >= 0, to.diff((0, _moment.default)(), 'days') >= 0) ? null : 'SEARCH_FORM:SEARCH_ERROR_WITH_INVALID_DATE';
  }], [function (_ref5) {
    var paramName = _ref5.paramName;
    return paramName === _fn.QUERY_PARAMS.COUNTRY;
  }, function (_ref6) {
    var paramValue = _ref6.paramValue;
    return paramValue ? null : 'SEARCH_FORM:SEARCH_ERROR_WITH_SOME_EMPTY_PARAMS';
  }], [function (_ref7) {
    var paramName = _ref7.paramName;
    return paramName === _fn.QUERY_PARAMS.DURATION;
  }, function (_ref8) {
    var _ref8$paramValue = _ref8.paramValue,
      from = _ref8$paramValue.from,
      to = _ref8$paramValue.to;
    return from && to ? null : 'SEARCH_FORM:SEARCH_ERROR_WITH_SOME_EMPTY_PARAMS';
  }], [R.propEq(_fn.QUERY_PARAMS.DEPARTURES, 'paramName'), function (_ref9) {
    var departures = _ref9.paramValue;
    return R.isEmpty(departures) ? 'SEARCH_FORM:SEARCH_ERROR_WITH_SOME_EMPTY_PARAMS' : null;
  }], [R.T, R.F]])), R.filter(Boolean), R.uniq), query);
};
var handleEmptyQueryParams = exports.handleEmptyQueryParams = function handleEmptyQueryParams(query) {
  return R.call(R.pipe(R.when(function (q) {
    return !q.get(_fn.QUERY_PARAMS.CURRENCY);
  }, function (q) {
    return q.set(_fn.QUERY_PARAMS.CURRENCY, 'uah');
  })), query);
};
var getGroupQueryParamByHotelsCount = exports.getGroupQueryParamByHotelsCount = function getGroupQueryParamByHotelsCount(count) {
  return R.call(R.cond([[R.equals(0), R.always(1)], [R.equals(1), R.always(undefined)], [function (c) {
    return c <= 2;
  }, R.always(63)], [function (c) {
    return c <= 20;
  }, R.always(1)], [R.T, R.always(1)]]), count);
};
var getInitialDatesForQuery = exports.getInitialDatesForQuery = function getInitialDatesForQuery() {
  var now = (0, _moment.default)();
  var from = now.startOf('day').add(7 + 5 - now.day(), 'days');
  return {
    from: from,
    to: from.clone().add(2, 'days')
  };
};